import { render } from "./features.vue?vue&type=template&id=6113f07c&scoped=true"
import script from "./features.vue?vue&type=script&lang=js"
export * from "./features.vue?vue&type=script&lang=js"

import "./features.vue?vue&type=style&index=0&id=6113f07c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6113f07c"]])

export default __exports__